module.exports = __webpack_public_path__ + "static/media/Scenario2Two.1ffa6b27.jpg";